import { render, staticRenderFns } from "./menu-item-group.vue?vue&type=template&id=a639fd7a"
import script from "./menu-item-group.vue?vue&type=script&lang=js"
export * from "./menu-item-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports